//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'pass_view',
  props: {
    pass: String,
    id: String
  },
  data() {
    return {
      isShow: true
    }
  },
  computed: {},
  methods: {
    enter() {
      let ps = document.getElementById('pass').value
      if (ps === this.pass) {
        this.$vux.loading.show({
          text: '正在进入现场...'
        })
        setTimeout(() => {
          this.$vux.loading.hide()
          // 计时1小时后要重新输入密码
          window.localStorage[this.id] = new Date()
          this.isShow = false
        }, 1500)
      } else {
        this.$vux.alert.show({
          title: '提示',
          content: '密码输入有误,请重试'
        })
        this.isShow = true
      }
    }
  },
  mounted() {},
  components: {}
}



// WEBPACK FOOTER //
// ./src/components/PassView/PassView.vue